import { Filter } from "../models/Filter";

export class GetByFiltersArguments {
    Tenant: number;
    Filters: Filter[];
    QuickSearchFilters: Filter[];
    FiltersExpression: string | null;
    PageIndex: number | null;
    PageSize: number | null;
    SortBy: string | null;
    SortDirection: string | null;
    PartnerTypeCode: string;
}